import { ModalActionTypes } from "./modal.types";

export const toggleModalHidden = () => ({
  type: ModalActionTypes.TOGGLE_MODAL_HIDDEN,
});
